import { render, staticRenderFns } from "./UserCart.vue?vue&type=template&id=e2005ece&scoped=true"
import script from "./UserCart.vue?vue&type=script&lang=js"
export * from "./UserCart.vue?vue&type=script&lang=js"
import style0 from "./UserCart.vue?vue&type=style&index=0&id=e2005ece&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2005ece",
  null
  
)

export default component.exports